import React, { forwardRef, useState } from "react";
import { Dropdown, Form } from "react-bootstrap";
import classNames from "classnames";

interface CheckDropdownItemProps {
    id: number;
    checked: boolean;
    onChange: (key: string, event: React.ChangeEvent<HTMLInputElement>) => void;
    children: React.ReactNode;
}

export const CheckDropdownItem = forwardRef<HTMLDivElement, CheckDropdownItemProps>(
    ({ children, id, checked, onChange }, ref) => {
        return (
            <Form.Group ref={ref} className="dropdown-item mb-0" controlId={id.toString()}>
                <Form.Check
                    type="checkbox"
                    label={children}
                    checked={checked}
                    onChange={onChange && onChange.bind(onChange, id.toString())}
                />
            </Form.Group>
        );
    }
);

interface CheckboxDropdownProps {
    items: { id: number; label: string; checked: boolean }[];
    handleChecked: (key: number, label: string, event: any) => void;
    className?: string;
    placeholder?: string;
    selectedPlaceholder?: string;
    displayDropdown?: boolean;
    setDisplayDropdown: (value: boolean) => void;
}


export const CustomDropDown = ({ items, handleChecked, className, placeholder, selectedPlaceholder, displayDropdown, setDisplayDropdown }: CheckboxDropdownProps): JSX.Element => {
    // const [displayDropdown, setDisplayDropdown] = useState(false);
    function selectedGroups(items: any) {
        let selectedGroups = [];
        for (let i = 0; i < items.length; i++) {
            if (items[i].checked) selectedGroups.push(items[i].label);
        }
        if (selectedGroups.length === 0) return placeholder ? placeholder : " ";
        if(selectedPlaceholder) return selectedPlaceholder;
        return selectedGroups.length + " Group Selected";
    }
    
    return (
        <Dropdown 
            autoClose="outside" 
            show={displayDropdown}
            onToggle={(isOpen) => setDisplayDropdown(isOpen)}
            className={classNames("stockgroup-dropdown", className)}
            >
            <Dropdown.Toggle variant="light" id="dropdown-basic">
                {selectedGroups(items)}
                { selectedGroups(items) === placeholder ? <></> : <div style={{color:"transparent"}}>.</div> }
                <i className="dripicons-chevron-down" style={{ color: "#6c757d", opacity: "0.8" }}></i>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                {items.map(i => (
                    <Dropdown.Item
                        key={i.id}
                        as={CheckDropdownItem}
                        id={i.id.toString()}
                        checked={i.checked}
                        onChange={() => handleChecked(i.id, i.label, !i.checked)}
                    >{i.label}</Dropdown.Item>
                ))}
            </Dropdown.Menu>
        </Dropdown>
    );
};
